import Vue from "vue";

import {
  getBalanceAccounts,
  addBalanceAccount,
  editUsedForAutoExchangeBalanceAccount,
  deleteBalanceAccount,
  editBalanceAccount,
  getBalanceAccountGroups,
  editBalanceAccountGroup,
  deleteBalanceAccountGroup
} from "@/api";
//
export default {
  namespaced: true,

  state: {
    balanceAccounts: {},
    verificationSummary: null,
    balanceAccountGroups: null,
    page: 1,
    limit: 50,
    sort: "-_id",
    loading: true,
    groupsLoading: true,
    groupSelected: null
  },

  mutations: {
    setBalanceAccounts(state, balanceAccounts) {
      state.balanceAccounts = balanceAccounts;
    },
    setVerificationSummary(state, verificationSummary) {
      state.verificationSummary = verificationSummary;
    },
    setBalanceAccountGroups(state, balanceAccountGroups) {
      state.balanceAccountGroups = balanceAccountGroups;
    },
    setGroupSelected(state, groupSelected) {
      state.groupSelected = groupSelected;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setGroupsLoading(state, groupsLoading) {
      state.groupsLoading = groupsLoading;
    }
  },

  actions: {
    async getBalanceAccounts(store, payload = {}) {
      try {
        store.commit("setLoading", true);
        const query = {
          ...(payload.query || {}),
          is_deposit: false,
          // $or: [{ isDeleted: false }, { isDeleted: { $exists: false } }],
          isDeleted: { $ne: true }
        };

        query.group = store.state.groupSelected
          ? store.state.groupSelected
          : undefined;

        const resp = await getBalanceAccounts({
          page: store.state.page,
          limit: store.state.limit,
          sort: store.state.sort,
          pagination: payload.notPaginate ? false : true,
          query
        });
        const res = {
          ...resp.data.result,
          docs: resp.data.result.docs.map(doc => {
            return {
              ...doc,
              isNew: doc._id === payload.newId
            };
          })
        };
        store.commit("setBalanceAccounts", res);
        store.commit("setVerificationSummary", resp.data.extra || null);
        return resp.data.result;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
    },
    async getBalanceAccountGroups(store, payload = {}) {
      try {
        store.commit("setGroupsLoading", true);
        const resp = await getBalanceAccountGroups({
          pagination: false
        });
        store.commit("setBalanceAccountGroups", resp.data.result);
        return resp.data.result;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setGroupsLoading", false);
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.balanceAccounts.totalPages &&
        store.state.balanceAccounts.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getBalanceAccounts");
        await store.dispatch("getBalanceAccountGroups");
      }
    },
    async changeLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
        await store.dispatch("getBalanceAccounts");
        await store.dispatch("getBalanceAccountGroups");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getBalanceAccounts");
        await store.dispatch("getBalanceAccountGroups");
      }
    },
    async changeGroupSelected(store, payload) {
      if (payload.groupSelected !== undefined) {
        store.commit("setGroupSelected", payload.groupSelected);
        await store.dispatch("getBalanceAccounts");
        await store.dispatch("getBalanceAccountGroups");
      }
    },
    async addBalanceAccount(store, balanceAccount) {
      try {
        store.commit("setLoading", true);
        const resp = await addBalanceAccount(balanceAccount);
        return resp;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
      // if (resp.data.status) {
      //   await store.dispatch("getBalanceAccounts", {
      //     newId: resp.data.result._id
      //   });
      //   await store.dispatch("getBalanceAccountGroups");
      // }
    },
    async editUsedForAutoExchangeBalanceAccount(store, { id, balanceAccount }) {
      try {
        store.commit("setLoading", true);
        const resp = await editUsedForAutoExchangeBalanceAccount(
          id,
          balanceAccount
        );
        return resp;

        // if (resp.data.status) {
        //   await store.dispatch("getBalanceAccounts");
        //   await store.dispatch("getBalanceAccountGroups");
        // }
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
    },
    async editBalanceAccountGroup(store, { id, group }) {
      try {
        store.commit("setLoading", true);
        const resp = await editBalanceAccountGroup(id, { group });
        return resp;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
    },
    async deleteBalanceAccount(store, id) {
      try {
        store.commit("setLoading", true);
        const resp = await deleteBalanceAccount(id);
        return resp;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
      // if (resp.data.status) {
      //   await store.dispatch("getBalanceAccounts");
      // }
    },
    async editBalanceAccount(store, { id, data }) {
      try {
        store.commit("setLoading", true);
        const resp = await editBalanceAccount(id, data);
        return resp;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
      // if (resp.data.status) {
      //   await store.dispatch("getBalanceAccounts");
      // }
    },
    async deleteBalanceAccountGroup(store, id) {
      try {
        store.commit("setLoading", true);
        const resp = await deleteBalanceAccountGroup(id);
        return resp;
      } catch (error) {
        throw error;
      } finally {
        store.commit("setLoading", false);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/balanceAccounts.js